<template>
  <!-- パスワードを忘れた方へ: 案内メッセージ -->
  <div class="p-login-form">
    <login-form-title text="パスワード及びIDをお忘れの方へ" />
    <div class="p-login-pass-lost">
      <div class="p-login-pass-lost__text">
        シグニティサポートチーム（<mail-to-link mail-address="support@signity.jp" link-text="support@signity.jp" />）までご連絡下さい。<br />
      </div>
    </div>
    <ul class="p-login-form-list p-login-form-list--bottom">
      <li class="p-login-form-list__item">
        <back-to-login-link :login-url="loginUrl" />
      </li>
    </ul>
  </div>
  <!-- /パスワードを忘れた方へ: 案内メッセージ -->
</template>

<script>
export default {
  props: {
    loginUrl: String,
  },
}
</script>
